import { AutogenModelCategory, AutogenRowCategory } from "./autogen/AutogenModelCategory";

export class ModelCategory extends AutogenModelCategory<RowCategory> {
    constructor() {
        super(RowCategory);
    }
}

export class RowCategory extends AutogenRowCategory {
}